export default {"src":"/_next/static/media/filterFunnel.9c60915e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};